var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.size=='small')?_c('div',{staticClass:"tag"},[_c('img',{attrs:{"src":"https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/search/living.gif","alt":""}}),_vm._v(" 直播中 ")]):_c('div',{staticClass:"tag-big"},[_c('img',{attrs:{"src":"https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/search/live_big.gif","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }